const LinkIcon = ({ color = 'currentColor', width = '20', height = '20' }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
                d="M8.33337 11.0243C8.45137 11.2176 8.59146 11.4005 8.75354 11.5692C9.75979 12.6164 11.2935 12.7802 12.4647 12.0603C12.6817 11.9269 12.8862 11.7632 13.0727 11.5692L15.7722 8.75966C16.9649 7.51836 16.9649 5.5058 15.7722 4.26448C14.5795 3.02316 12.6457 3.02317 11.453 4.26448L10.8584 4.88331"
                stroke="#002394"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M9.14196 15.1167L8.54713 15.7357C7.35443 16.977 5.42063 16.977 4.22792 15.7357C3.03519 14.4943 3.03519 12.4818 4.22792 11.2405L6.92743 8.431C8.12015 7.18967 10.054 7.18966 11.2466 8.431C11.4087 8.59958 11.5487 8.7825 11.6667 8.97566"
                stroke="#002394"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};

export default LinkIcon;
